"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialBookingModularModule = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var trialbooking_documentation_1 = require("@const/documentations/trialbooking.documentation");
var ci_component_injector_service_1 = require("@services/ci-component-injector.service");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var magicline_api_1 = require("../../../api/magicline-api");
var fittec_api_1 = require("../../../api/fittec-api");
var api_wrapper_1 = require("../../../api/api-wrapper");
var brings_a_friend_helper_1 = require("./helpers/brings-a-friend.helper");
var studio_dropdown_helper_1 = require("./helpers/studio-dropdown.helper");
var trial_booking_helper_1 = require("./helpers/trial-booking.helper");
var TRIAL_BOOKING_STORAGE_KEYS = {
    date: 'trialbooking_date',
    time: 'trialbooking_time',
    bringAFriend: 'trialbooking_bring_a_friend',
};
var TrialBookingModularModule = /** @class */ (function () {
    function TrialBookingModularModule() {
        this.magiclineApi = object_service_1.ObjectService.getInstance(magicline_api_1.MagiclineApi);
        this.fittecApi = object_service_1.ObjectService.getInstance(fittec_api_1.FittecApi);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.interComService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.validBirthdayModule = false;
        this.trialBookingMapping = input_mapping_const_1._TrialBookingMapping;
        this.state = {
            currentStep: 'datepicker',
        };
        this.hasSelectedDate = false;
        this.withTrainer = false;
        this.trialBookingRequestId = 0;
        this.trialBookins = {
            description: '',
            name: '',
            slots: [],
        };
        this.handleDatepickerChangeEvent = this.handleDatepickerChangeEvent.bind(this);
        this.slotSelected = this.slotSelected.bind(this);
        this.submitTrialBooking = this.submitTrialBooking.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.studioLocationDropdownSelected = this.studioLocationDropdownSelected.bind(this);
        this.handleAppointmentTrainerSwitchChange = this.handleAppointmentTrainerSwitchChange.bind(this);
    }
    TrialBookingModularModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storedStudioId, configuredStudioId, shouldLoadInitialTrialBookings;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (0, cash_dom_1.default)('head').append((0, trial_booking_helper_1.getTrialBookingBaseStyles)());
                        (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                        (0, trial_booking_helper_1.addInitialPlaceholderTags)(this.$container);
                        this.selectedStartDate = new Date();
                        this.selectedEndDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
                        this.selectedDate = this.formatCalendarDate(new Date());
                        this.datePickerDate = this.selectedDate;
                        this.trialBookingMapping = (0, trial_booking_helper_1.getTrialBookingFieldMapping)(this.$container);
                        this.setupStudioDropdown();
                        this.setupAppointmentTrainerSwitch();
                        this.setupBringsAFriend();
                        this.setupDatepicker();
                        this.setupSlotpicker();
                        this.setupSubmitButtons();
                        this.setupNavigationButtons();
                        this.setupSelectedSlotDisplay();
                        this.setupBirthdayValidation();
                        this.renderTrialSessionAvailability();
                        storedStudioId = this.getStoredStudioId();
                        configuredStudioId = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.studioId;
                        shouldLoadInitialTrialBookings = false;
                        if (this.isExternalStudioSelectionEnabled() && storedStudioId) {
                            this.studioId = storedStudioId;
                            shouldLoadInitialTrialBookings = true;
                        }
                        else if (!this.hasStudioSelection() && configuredStudioId) {
                            this.studioId = configuredStudioId.toString();
                            shouldLoadInitialTrialBookings = true;
                        }
                        this.state.currentStep = this.getInitialStep();
                        this.renderState();
                        if (!shouldLoadInitialTrialBookings) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateTrialBookings()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.setupStudioDropdown = function () {
        var _a, _b, _c, _d;
        this.locationSelection = this.$container.find('*[data-module="dropdown"][data-type="studioLocation"]');
        if (this.locationSelection.length != 0) {
            this.locationSelection.on('change', this.studioLocationDropdownSelected);
        }
        var dropdownRef = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.studioDropdown) === null || _b === void 0 ? void 0 : _b.domElement;
        if (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.length) {
            var dropdownClass_1 = object_service_1.ObjectService.getInstance(studio_dropdown_helper_1.StudioDropdown);
            dropdownClass_1.getStudios(this.config).then(function () {
                dropdownClass_1.updateDropdown(dropdownRef);
            });
            dropdownRef.on('change', this.studioLocationDropdownSelected);
        }
        var searchRef = (_d = (_c = this.module.references) === null || _c === void 0 ? void 0 : _c.studioSearch) === null || _d === void 0 ? void 0 : _d.domElement;
        if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.length) && (searchRef === null || searchRef === void 0 ? void 0 : searchRef.length)) {
            var dropdownClass_2 = object_service_1.ObjectService.getInstance(studio_dropdown_helper_1.StudioDropdown);
            searchRef.on('input', function (event) {
                dropdownClass_2.updateDropdown(dropdownRef, (0, cash_dom_1.default)(event.target).val());
            });
            searchRef.on('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
            searchRef.attr('type', 'search').attr('enterkeyhint', 'search').attr('autocomplete', 'off');
        }
    };
    TrialBookingModularModule.prototype.setupBringsAFriend = function () {
        (0, brings_a_friend_helper_1.setupBringsAFriendForm)(this.$container, this.module.references);
        var uid = trialbooking_documentation_1._TrialBookingModularCustomReferences.bringsAFriend.uid;
        var checkbox = this.$container.find("input[type=\"checkbox\"][data-get=\"".concat(uid, "\"]"));
        var saveBringsAFriend = function () {
            localStorage.setItem(TRIAL_BOOKING_STORAGE_KEYS.bringAFriend, String(checkbox.prop('checked') === true));
        };
        checkbox.on('change', saveBringsAFriend);
        saveBringsAFriend();
    };
    TrialBookingModularModule.prototype.setupAppointmentTrainerSwitch = function () {
        var uid = trialbooking_documentation_1._TrialBookingModularCustomReferences.appointmentTrainerSwitch.uid;
        var appointmentTrainerSwitch = this.$container.find("input[type=\"checkbox\"][data-get=\"".concat(uid, "\"]"));
        this.withTrainer = appointmentTrainerSwitch.first().prop('checked') === true;
        appointmentTrainerSwitch.on('change', this.handleAppointmentTrainerSwitchChange);
    };
    TrialBookingModularModule.prototype.handleAppointmentTrainerSwitchChange = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.withTrainer = (0, cash_dom_1.default)(event.currentTarget).prop('checked') === true;
                        this.selectedSlot = undefined;
                        localStorage.removeItem(TRIAL_BOOKING_STORAGE_KEYS.time);
                        this.updateNextButtonState();
                        return [4 /*yield*/, this.updateTrialBookings()];
                    case 1:
                        _a.sent();
                        this.updateSlotSelection();
                        return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.setupDatepicker = function () {
        var _a, _b, _c, _d;
        var datepickerContainer = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.datepicker) === null || _b === void 0 ? void 0 : _b.domElement;
        if (!(datepickerContainer === null || datepickerContainer === void 0 ? void 0 : datepickerContainer.length)) {
            console.error("Trial booking modular module missing a data-ref='datepicker' container");
            return;
        }
        var dimensions = (0, trial_booking_helper_1.isMobileScreenSize)() ? '{"dayWidth": 40, "dayHeight": 40}' : '{"dayWidth": 50, "dayHeight": 50}';
        var datepickerColorObject = (_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.trialBooking) === null || _d === void 0 ? void 0 : _d.colors;
        var datePickerColors = datepickerColorObject
            ? 'colors="' + JSON.stringify(datepickerColorObject).replace(/"/g, "'") + '"'
            : '';
        this.datePicker = (0, cash_dom_1.default)("<ci-datepicker open=\"true\" close-on-selection=\"false\" dimensions='".concat(dimensions, "' ").concat(datePickerColors, " animations=\"false\" disable-past-days=\"true\" disable-future-days=\"true\"></ci-datepicker>"));
        this.datePicker.attr('inject-css', this.getDatepickerLimitStyles());
        this.changeDatepickerStatus('disabled');
        datepickerContainer.append(this.datePicker);
        datepickerContainer.on('change', 'ci-datepicker', this.handleDatepickerChangeEvent);
    };
    TrialBookingModularModule.prototype.formatCalendarDate = function (date) {
        return "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'));
    };
    TrialBookingModularModule.prototype.getLastBookableDate = function () {
        var _a, _b;
        var days = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.trialBooking) === null || _b === void 0 ? void 0 : _b.maxDaysInFuture;
        if (!Number.isInteger(days) || days < 0)
            return undefined;
        var lastDate = new Date();
        lastDate.setHours(0, 0, 0, 0);
        lastDate.setDate(lastDate.getDate() + days);
        return Number.isNaN(lastDate.getTime()) ? undefined : lastDate;
    };
    TrialBookingModularModule.prototype.isBookableDate = function (date) {
        if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(date))
            return false;
        var lastDate = this.getLastBookableDate();
        return date >= this.formatCalendarDate(new Date()) && (!lastDate || date <= this.formatCalendarDate(lastDate));
    };
    TrialBookingModularModule.prototype.getDatepickerLimitStyles = function () {
        var disabledSelectors = [':host([disabled="true"]) .day', '.day.pallet-disabled-color'];
        var lastDate = this.getLastBookableDate();
        if (lastDate) {
            // ci-datepicker has no max-date prop. Its CSS hook can disable ISO day cells
            // across every month without affecting the month/year navigation cells.
            var allowedSelectors = [];
            var day = new Date();
            day.setHours(0, 0, 0, 0);
            while (day <= lastDate) {
                var year = day.getFullYear();
                var month = day.getMonth();
                if (month === 0 && day.getDate() === 1 && new Date(year, 11, 31) <= lastDate) {
                    allowedSelectors.push("[data-date^=\"".concat(year, "-\"]"));
                    day.setFullYear(year + 1);
                }
                else if (day.getDate() === 1 && new Date(year, month + 1, 0) <= lastDate) {
                    allowedSelectors.push("[data-date^=\"".concat(this.formatCalendarDate(day).slice(0, 7), "-\"]"));
                    day.setMonth(month + 1);
                }
                else {
                    allowedSelectors.push("[data-date=\"".concat(this.formatCalendarDate(day), "\"]"));
                    day.setDate(day.getDate() + 1);
                }
            }
            disabledSelectors.push(".day[data-date*=\"-\"]:not(:is(".concat(allowedSelectors.join(','), "))"));
        }
        return "".concat(disabledSelectors.join(','), " { pointer-events: none; opacity: 0.35 !important; }");
    };
    TrialBookingModularModule.prototype.setupSlotpicker = function () {
        var _a, _b;
        var slotpickerContainer = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.slotpicker) === null || _b === void 0 ? void 0 : _b.domElement;
        if (!(slotpickerContainer === null || slotpickerContainer === void 0 ? void 0 : slotpickerContainer.length)) {
            console.error("Trial booking modular module missing a data-ref='slotpicker' container");
            return;
        }
        this.slotPickerContent = (0, cash_dom_1.default)('<div data-generated="trial-booking-slotpicker"></div>');
        slotpickerContainer.parent().append(this.slotPickerContent);
    };
    TrialBookingModularModule.prototype.setupSubmitButtons = function () {
        var _this = this;
        var submitButtonQuery = this.$container.find('*[data-action="trailbooking.submit"]');
        if (submitButtonQuery.length > 0) {
            submitButtonQuery.off();
            submitButtonQuery.on('click', this.submitTrialBooking);
        }
        else {
            console.error("no button with data-action='trailbooking.submit' found!");
        }
        if (submitButtonQuery.length > 0) {
            var submitbutton = submitButtonQuery.closest('form');
            (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(submitbutton, function () {
                _this.submitTrialBooking();
            });
        }
        this.webflowSubmitButton = this.$container.find('*[data-action="webflow-submit"]');
        if (this.webflowSubmitButton.length === 0) {
            console.error("no button with data-action='webflow-submit' found!");
        }
    };
    TrialBookingModularModule.prototype.setupNavigationButtons = function () {
        this.backButton = this.$container.find('*[data-action="back"]');
        if (this.backButton.length > 0) {
            this.backButton.off();
            this.backButton.on('click', this.handleBackButton);
        }
        this.nextButton = this.$container.find('*[data-action="next"]');
        if (this.nextButton.length > 0) {
            this.nextButton.off();
            this.nextButton.on('click', this.handleNextButton);
        }
    };
    TrialBookingModularModule.prototype.setupSelectedSlotDisplay = function () {
        this.selectedSlotWrapper = this.$container.find('*[data-get="selectedSlot"]');
        if (this.selectedSlotWrapper.length > 0) {
            this.selectedSlotWrapper.css({
                display: 'none',
            });
            this.selectedSlotElement = (0, cash_dom_1.default)('<div></div>');
            this.selectedSlotWrapper.append(this.selectedSlotElement);
        }
    };
    TrialBookingModularModule.prototype.setupBirthdayValidation = function () {
        var _this = this;
        this.interComService.subscribeChildren(this).subscribe(function (event) {
            if (event.event === 'validation' && event.module.moduleKey === 'birthday') {
                _this.validBirthdayModule = event.value.valid;
                if (event.value.valid) {
                    (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.age, event.value.data.age);
                    (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth, event.value.data.birthday);
                }
            }
            if (event.event === 'custom' && event.module.moduleKey === 'studio-selection' && event.name === 'studioSelected') {
                _this.studioSelected(localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid) || '');
            }
        });
    };
    TrialBookingModularModule.prototype.getInitialStep = function () {
        if (this.studioId)
            return 'datepicker';
        return this.hasStudioSelection() && this.getStepContainer('studio').length ? 'studio' : 'datepicker';
    };
    TrialBookingModularModule.prototype.hasStudioSelection = function () {
        var _a, _b, _c, _d;
        return Boolean(this.isExternalStudioSelectionEnabled() ||
            ((_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.studioDropdown) === null || _b === void 0 ? void 0 : _b.domElement) === null || _c === void 0 ? void 0 : _c.length) ||
            ((_d = this.locationSelection) === null || _d === void 0 ? void 0 : _d.length) ||
            this.getStepContainer('studio').find('[data-module="studio-selection"]').length);
    };
    TrialBookingModularModule.prototype.isExternalStudioSelectionEnabled = function () {
        var _a, _b;
        return ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.trialBooking) === null || _b === void 0 ? void 0 : _b.externalStudioSelection) === true;
    };
    TrialBookingModularModule.prototype.usesFittecCalendar = function () {
        var _a, _b;
        return ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.trialBooking) === null || _b === void 0 ? void 0 : _b.useFittecCalendar) === true;
    };
    TrialBookingModularModule.prototype.getStoredStudioId = function () {
        return localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid) || '';
    };
    TrialBookingModularModule.prototype.renderTrialSessionAvailability = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var datepickerContainer = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a.datepicker) === null || _b === void 0 ? void 0 : _b.domElement;
        var unavailable = this.trialSessionBookable === false;
        this.changeDatepickerStatus(this.trialSessionBookable === true ? 'enabled' : 'disabled');
        this.updateNextButtonState();
        if (unavailable) {
            (_c = this.datePicker) === null || _c === void 0 ? void 0 : _c.detach();
            if (!this.noTrialSessionWarning) {
                this.noTrialSessionWarning =
                    (_g = (_f = (_e = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.noTrialSessionBookable) === null || _e === void 0 ? void 0 : _e.cloneDomElement) === null || _f === void 0 ? void 0 : _f.call(_e)) !== null && _g !== void 0 ? _g : (0, cash_dom_1.default)('<div class="error" role="alert"></div>').text(translation_1.default.t('This studio currently does not offer trial session'));
                this.noTrialSessionWarning.css({ display: 'block' });
                datepickerContainer === null || datepickerContainer === void 0 ? void 0 : datepickerContainer.append(this.noTrialSessionWarning);
            }
            this.noTrialSessionWarning
                .find('[data-get="trialbooking-description"]')
                .text(this.trialBookins.description || translation_1.default.t('This studio currently does not offer trial session'));
        }
        else {
            (_h = this.noTrialSessionWarning) === null || _h === void 0 ? void 0 : _h.remove();
            this.noTrialSessionWarning = undefined;
            if ((_j = this.datePicker) === null || _j === void 0 ? void 0 : _j.length)
                datepickerContainer === null || datepickerContainer === void 0 ? void 0 : datepickerContainer.append(this.datePicker);
        }
    };
    TrialBookingModularModule.prototype.getStepContainer = function (step) {
        var _a, _b, _c;
        var referenceKey = "".concat(step, "Step");
        return (_c = (_b = (_a = this.module.references) === null || _a === void 0 ? void 0 : _a[referenceKey]) === null || _b === void 0 ? void 0 : _b.domElement) !== null && _c !== void 0 ? _c : (0, cash_dom_1.default)();
    };
    TrialBookingModularModule.prototype.renderState = function () {
        var _this = this;
        var _a, _b;
        ['studio', 'datepicker', 'slotpicker', 'form'].forEach(function (step) {
            _this.getStepContainer(step).css({
                display: _this.state.currentStep === step ? 'block' : 'none',
            });
        });
        if ((_a = this.selectedSlotWrapper) === null || _a === void 0 ? void 0 : _a.length) {
            this.selectedSlotWrapper.css({
                display: this.state.currentStep === 'form' && this.selectedSlot ? 'block' : 'none',
            });
        }
        if ((_b = this.backButton) === null || _b === void 0 ? void 0 : _b.length) {
            this.backButton.css({
                display: this.canGoBack() ? 'block' : 'none',
            });
        }
        this.updateNextButtonState();
    };
    TrialBookingModularModule.prototype.setStep = function (step) {
        this.state.currentStep = step;
        this.renderState();
    };
    TrialBookingModularModule.prototype.canGoBack = function () {
        if (this.state.currentStep === 'form')
            return true;
        if (this.state.currentStep === 'slotpicker')
            return true;
        return this.state.currentStep === 'datepicker' && this.hasStudioSelection() && this.getStepContainer('studio').length > 0;
    };
    TrialBookingModularModule.prototype.canGoNext = function (step) {
        if (step === void 0) { step = this.state.currentStep; }
        if (step === 'studio')
            return Boolean(this.studioId) && this.trialSessionBookable !== undefined;
        if (this.trialSessionBookable !== true)
            return false;
        switch (step) {
            case 'datepicker':
                return this.hasSelectedDate;
            case 'slotpicker':
                return Boolean(this.selectedSlot);
            default:
                return false;
        }
    };
    TrialBookingModularModule.prototype.usesManualNavigation = function (step) {
        var _this = this;
        var _a;
        if (!((_a = this.nextButton) === null || _a === void 0 ? void 0 : _a.length))
            return false;
        return this.nextButton.get().some(function (button) { return _this.nextButtonAppliesToStep((0, cash_dom_1.default)(button), step); });
    };
    TrialBookingModularModule.prototype.updateNextButtonState = function () {
        var _this = this;
        var _a;
        if (!((_a = this.nextButton) === null || _a === void 0 ? void 0 : _a.length))
            return;
        var currentStep = this.state.currentStep;
        this.nextButton.each(function (_, button) {
            var _a;
            var $button = (0, cash_dom_1.default)(button);
            var buttonStep = (_a = _this.getStepForElement($button)) !== null && _a !== void 0 ? _a : currentStep;
            var buttonAppliesToCurrentStep = _this.nextButtonAppliesToStep($button, currentStep);
            $button.toggleClass('disabled', !_this.canGoNext(buttonStep));
            $button.css({
                display: currentStep !== 'form' && buttonAppliesToCurrentStep ? 'block' : 'none',
            });
        });
    };
    TrialBookingModularModule.prototype.nextButtonAppliesToStep = function (button, step) {
        var buttonStep = this.getStepForElement(button);
        return !buttonStep || buttonStep === step;
    };
    TrialBookingModularModule.prototype.getStepForElement = function (element) {
        var _this = this;
        var domElement = element[0];
        if (!domElement)
            return undefined;
        var steps = ['studio', 'datepicker', 'slotpicker', 'form'];
        return steps.find(function (step) {
            var stepElement = _this.getStepContainer(step)[0];
            return stepElement && (stepElement === domElement || stepElement.contains(domElement));
        });
    };
    TrialBookingModularModule.prototype.handleBackButton = function (event) {
        event.preventDefault();
        if (this.state.currentStep === 'form') {
            this.setStep('slotpicker');
            return;
        }
        if (this.state.currentStep === 'slotpicker') {
            this.setStep('datepicker');
            return;
        }
        if (this.state.currentStep === 'datepicker' && this.hasStudioSelection()) {
            this.setStep('studio');
        }
    };
    TrialBookingModularModule.prototype.handleNextButton = function (event) {
        event.preventDefault();
        if (!this.nextButtonAppliesToStep((0, cash_dom_1.default)(event.currentTarget), this.state.currentStep))
            return;
        if (this.state.currentStep !== 'studio' && this.studioId && this.trialSessionBookable !== true) {
            this.renderTrialSessionAvailability();
            return;
        }
        if (this.state.currentStep === 'studio') {
            if (!this.studioId) {
                (0, generator_const_1._ShowErrorMessage)('Please select a studio');
                return;
            }
            (0, generator_const_1._HideErrorMessage)();
            this.setStep('datepicker');
            return;
        }
        if (this.state.currentStep === 'datepicker') {
            if (!this.hasSelectedDate) {
                (0, generator_const_1._ShowErrorMessage)('Please select a date');
                return;
            }
            (0, generator_const_1._HideErrorMessage)();
            this.updateSlotSelection();
            this.setStep('slotpicker');
            return;
        }
        if (this.state.currentStep === 'slotpicker') {
            if (!this.selectedSlot) {
                (0, generator_const_1._ShowErrorMessage)('Please select a time');
                return;
            }
            (0, generator_const_1._HideErrorMessage)();
            this.enterFormStep(this.selectedSlot);
        }
    };
    TrialBookingModularModule.prototype.resetSlotSelectContainer = function () {
        var _a;
        if (!((_a = this.slotPickerContent) === null || _a === void 0 ? void 0 : _a.length))
            return;
        this.slotPickerContent.empty();
    };
    TrialBookingModularModule.prototype.getTrailBookingSlots = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestId, studioId_1, studios, studio, trialBookings, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.selectedStartDate && this.selectedEndDate && this.studioId)) return [3 /*break*/, 5];
                        requestId = ++this.trialBookingRequestId;
                        studioId_1 = this.studioId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!this.studiosPromise) {
                            this.studiosPromise = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper)
                                .getStudios()
                                .catch(function (error) {
                                _this.studiosPromise = undefined;
                                throw error;
                            });
                        }
                        return [4 /*yield*/, this.studiosPromise];
                    case 2:
                        studios = _a.sent();
                        if (requestId !== this.trialBookingRequestId)
                            return [2 /*return*/];
                        studio = studios.find(function (candidate) { return candidate.id.toString() === studioId_1; });
                        this.trialSessionBookable = (studio === null || studio === void 0 ? void 0 : studio.trialSessionBookable) !== false;
                        this.renderTrialSessionAvailability();
                        return [4 /*yield*/, (this.usesFittecCalendar()
                                ? this.fittecApi.getTrialBookingSlots(studioId_1, this.selectedStartDate, this.selectedEndDate, this.withTrainer)
                                : this.magiclineApi.getTrialBookings(+studioId_1, this.selectedStartDate, this.selectedEndDate))];
                    case 3:
                        trialBookings = _a.sent();
                        if (requestId !== this.trialBookingRequestId)
                            return [2 /*return*/];
                        this.trialBookins = __assign(__assign({}, trialBookings), { slots: this.trialSessionBookable
                                ? trialBookings.slots.filter(function (slot) { return _this.isBookableDate(slot.startDateTime.split('T')[0]); })
                                : [] });
                        this.renderTrialSessionAvailability();
                        if (!this.trialSessionBookable)
                            return [2 /*return*/];
                        if (this.trialBookins.slots.length === 0) {
                            (0, generator_const_1._ShowErrorMessage)('No trial bookings found for this month');
                        }
                        else {
                            (0, generator_const_1._HideErrorMessage)();
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        if (requestId !== this.trialBookingRequestId)
                            return [2 /*return*/];
                        console.error('Error trying to get magicline trail-booking slots:', e_1);
                        this.trialBookins = {
                            description: '',
                            name: '',
                            slots: [],
                        };
                        if (this.trialSessionBookable === false) {
                            this.renderTrialSessionAvailability();
                        }
                        else {
                            (0, generator_const_1._ShowErrorMessage)('Error trying to get trial bookings');
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.updateTrialBookings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var uniqueDays, datepicker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, generator_const_1._CreateLoadingScreen)(this.getStepContainer('datepicker'));
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.getTrailBookingSlots()];
                    case 2:
                        _a.sent();
                        uniqueDays = (0, trial_booking_helper_1.getUniqueTrialBookingDays)(this.trialBookins);
                        this.datePicker.prop('highlight-days', uniqueDays);
                        datepicker = this.datePicker[0];
                        datepicker.highlightDays = uniqueDays;
                        return [3 /*break*/, 4];
                    case 3:
                        (0, generator_const_1._DeleteLoadingScreen)(this.getStepContainer('datepicker'));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.updateSlotSelection = function () {
        var _this = this;
        var applicableSlots = this.trialBookins.slots.filter(function (slot) { return slot.startDateTime.split('T')[0] === _this.selectedDate; });
        this.resetSlotSelectContainer();
        var slotWrapper = (0, cash_dom_1.default)('<div style="display:flex;flex-wrap:wrap;margin-top: 1.5em;"></div>');
        applicableSlots.forEach(function (slot) {
            var _a, _b;
            var slotDetails = (0, trial_booking_helper_1.slotToDetails)(slot);
            var slotText = slotDetails.formattedStartTime + ' - ' + slotDetails.formattedEndTime;
            var slotDiv = (0, cash_dom_1.default)('<div class="fittec-trial-booking-slot-wrapper"></div>');
            var slotSpan = (0, cash_dom_1.default)('<span class="fittec-trial-booking-slot-text"></span>').text(slotText);
            if (slot.startDateTime === ((_a = _this.selectedSlot) === null || _a === void 0 ? void 0 : _a.startDateTime) && slot.endDateTime === ((_b = _this.selectedSlot) === null || _b === void 0 ? void 0 : _b.endDateTime)) {
                slotDiv.addClass('fittec-trial-booking-slot-wrapper-selected');
                slotSpan.addClass('fittec-trial-booking-slot-text-selected');
            }
            slotDiv.append(slotSpan);
            slotDiv.on('click', function () { return _this.slotSelected(slot); });
            slotWrapper.append(slotDiv);
        });
        this.slotPickerContent.append(slotWrapper);
    };
    TrialBookingModularModule.prototype.slotSelected = function (slot) {
        if (this.trialSessionBookable !== true || !this.isBookableDate(slot.startDateTime.split('T')[0]))
            return;
        this.selectedSlot = slot;
        localStorage.setItem(TRIAL_BOOKING_STORAGE_KEYS.time, slot.startDateTime.split('T')[1].slice(0, 5));
        this.updateNextButtonState();
        (0, generator_const_1._HideErrorMessage)();
        if (!this.usesManualNavigation('slotpicker')) {
            this.enterFormStep(slot);
        }
        this.updateSlotSelection();
    };
    TrialBookingModularModule.prototype.enterFormStep = function (slot) {
        var _a;
        (0, trial_booking_helper_1.readTrialBookingLocalStorage)(this.$container, this.trialBookingMapping);
        if (slot) {
            (0, trial_booking_helper_1.fillTrialBookingHiddenFields)(this.$container, slot);
            (0, trial_booking_helper_1.replaceTrialBookingPlaceholdersTimeslots)(this.$container, slot);
        }
        if (((_a = this.selectedSlotWrapper) === null || _a === void 0 ? void 0 : _a.length) && this.selectedSlot) {
            this.setSelectedSlotWrapperText();
        }
        this.setStep('form');
    };
    TrialBookingModularModule.prototype.studioLocationDropdownSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedValue, selectedStudioId;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        selectedValue = (0, cash_dom_1.default)(event.target).val();
                        selectedStudioId = (_a = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.toString()) !== null && _a !== void 0 ? _a : '';
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioId, selectedStudioId);
                        return [4 /*yield*/, this.studioSelected(selectedStudioId, selectedValue !== 'Bitte wählen')];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.studioSelected = function (selectedStudioId_1) {
        return __awaiter(this, arguments, void 0, function (selectedStudioId, isValid) {
            var datepicker;
            var _a;
            if (isValid === void 0) { isValid = selectedStudioId.length > 0; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ++this.trialBookingRequestId;
                        this.studioId = isValid ? selectedStudioId : '';
                        this.trialSessionBookable = undefined;
                        this.trialBookins = { description: '', name: '', slots: [] };
                        (0, generator_const_1._HideErrorMessage)();
                        this.renderTrialSessionAvailability();
                        this.selectedSlot = undefined;
                        this.hasSelectedDate = false;
                        localStorage.removeItem(TRIAL_BOOKING_STORAGE_KEYS.date);
                        localStorage.removeItem(TRIAL_BOOKING_STORAGE_KEYS.time);
                        this.updateNextButtonState();
                        this.resetSlotSelectContainer();
                        if (!isValid) return [3 /*break*/, 2];
                        (0, generator_const_1._HideErrorMessage)();
                        if (!this.usesManualNavigation('studio')) {
                            this.setStep('datepicker');
                        }
                        return [4 /*yield*/, this.updateTrialBookings()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                    case 2:
                        this.trialBookins = {
                            description: '',
                            name: '',
                            slots: [],
                        };
                        datepicker = (_a = this.datePicker) === null || _a === void 0 ? void 0 : _a[0];
                        if (datepicker) {
                            datepicker.highlightDays = [];
                        }
                        this.changeDatepickerStatus('disabled');
                        this.setStep(this.getInitialStep());
                        return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.handleDatepickerChangeEvent = function (event) {
        var _a, _b, _c;
        if (this.trialSessionBookable !== true)
            return;
        if (((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) === 'days-view') {
            try {
                var newDate = event.detail.data.value.year + '-' + event.detail.data.value.month + '-' + event.detail.data.value.day;
                if (this.datePickerDate != newDate) {
                    this.datePickerDate = newDate;
                    var startDate = new Date(Date.UTC(event.detail.data.value.year, event.detail.data.value.month, 1));
                    var endDate = new Date(Date.UTC(event.detail.data.value.year, event.detail.data.value.month + 1, 0));
                    if (startDate < new Date()) {
                        startDate = new Date();
                    }
                    this.selectedStartDate = startDate;
                    this.selectedEndDate = endDate;
                    if (endDate > new Date()) {
                        this.updateTrialBookings();
                    }
                }
            }
            catch (e) {
                console.error('failed getting date from datepicker:', e);
            }
        }
        else if (((_c = event.detail) === null || _c === void 0 ? void 0 : _c.statusText) === 'value-changed') {
            if (!this.isBookableDate(event.detail.data))
                return;
            this.selectedDate = event.detail.data;
            localStorage.setItem(TRIAL_BOOKING_STORAGE_KEYS.date, this.selectedDate);
            localStorage.removeItem(TRIAL_BOOKING_STORAGE_KEYS.time);
            this.hasSelectedDate = true;
            this.selectedSlot = undefined;
            this.updateNextButtonState();
            (0, generator_const_1._HideErrorMessage)();
            this.updateSlotSelection();
            if (!this.usesManualNavigation('datepicker')) {
                this.setStep('slotpicker');
            }
        }
    };
    TrialBookingModularModule.prototype.submitTrialBooking = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var validationRes, customerData, participantData, participantInputCount, participants, bookingData, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (event) {
                            event.preventDefault();
                        }
                        if (this.trialSessionBookable !== true) {
                            this.renderTrialSessionAvailability();
                            return [2 /*return*/];
                        }
                        (0, generator_const_1._HideErrorMessage)();
                        if ((0, cash_dom_1.default)(event === null || event === void 0 ? void 0 : event.target).hasClass('triggered-submit'))
                            return [2 /*return*/];
                        validationRes = (0, input_output_helper_const_1._ValidateFields)(this.getStepContainer('form'), {
                            showErrors: true,
                            showSuccess: false,
                            animateToFirstError: true,
                            mappings: this.trialBookingMapping,
                        }, true);
                        if (!this.selectedSlot || !this.isBookableDate(this.selectedSlot.startDateTime.split('T')[0])) {
                            console.error('No slot selected for trial session!');
                            (0, generator_const_1._ShowErrorMessage)('Please select a time');
                            return [2 /*return*/];
                        }
                        if (!(validationRes.valid && (this.validBirthdayModule || this.$container.find("[data-module='birthday']").length === 0))) return [3 /*break*/, 8];
                        (0, generator_const_1._CreateLoadingScreen)(this.getStepContainer('form'));
                        customerData = validationRes.data.customer;
                        participantData = (0, brings_a_friend_helper_1.readTrialBookingFriendParticipants)(this.$container);
                        participantInputCount = Number(validationRes.data.participants);
                        participants = participantData.length
                            ? participantData.length + 1
                            : Number.isNaN(participantInputCount)
                                ? undefined
                                : participantInputCount;
                        bookingData = (0, trial_booking_helper_1.createMagiclineTrialBookingData)(this.selectedSlot, +this.studioId, customerData, this.config, {
                            participants: participants,
                            participantData: participantData,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!this.usesFittecCalendar()) return [3 /*break*/, 3];
                        bookingData.source = __assign({ type: 'website' }, (this.config.get.funnelConfigId ? { funnelConfigId: this.config.get.funnelConfigId } : {}));
                        return [4 /*yield*/, this.fittecApi.createTrialBooking(bookingData)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.magiclineApi.createTrialBooking(bookingData)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        (0, generator_const_1._DeleteLoadingScreen)(this.getStepContainer('form'));
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        console.error('Error trying to create a trail booking:', e_2);
                        (0, generator_const_1._DeleteLoadingScreen)(this.getStepContainer('form'));
                        return [2 /*return*/];
                    case 7:
                        this.webflowSubmitButton.addClass('triggered-submit').trigger('click').removeClass('triggered-submit');
                        return [3 /*break*/, 9];
                    case 8:
                        console.error('trail booking form validation failed:', validationRes, 'birthday: ', this.validBirthdayModule);
                        (0, generator_const_1._ShowErrorMessage)('Please fill out all fields');
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModularModule.prototype.setSelectedSlotWrapperText = function () {
        var _a;
        if (!this.selectedSlot)
            return;
        (_a = this.selectedSlotElement) === null || _a === void 0 ? void 0 : _a.remove();
        this.selectedSlotElement = (0, trial_booking_helper_1.createSelectedTimeslotContainer)(this.selectedSlot);
        this.selectedSlotWrapper.append(this.selectedSlotElement);
    };
    TrialBookingModularModule.prototype.changeDatepickerStatus = function (newStatus) {
        var _a;
        if (!((_a = this.datePicker) === null || _a === void 0 ? void 0 : _a.length))
            return;
        this.datePicker.attr('disabled', String(newStatus === 'disabled'));
        this.datePicker.attr('disable-future-days', String(newStatus === 'disabled'));
        this.datePicker.attr('disable-past-days', 'true');
    };
    return TrialBookingModularModule;
}());
exports.TrialBookingModularModule = TrialBookingModularModule;
